import axios from 'services/core/HttpService';
import {
    GET_FILTER_SUPPORT_USERS,
    LOGIN_AS_USER,
} from 'services/constant/apiRoutes';

// Get filtered support users
export const getFilterSupportUsers = (filter: string) => {
    return new Promise((resolve, reject) => {
        axios
            .get(GET_FILTER_SUPPORT_USERS + `?search=${filter}`)
            .then((response) => {
                resolve(response);
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const loginAsUser = (userId: number) => {
    return new Promise((resolve, reject) => {
        axios.post(LOGIN_AS_USER.replace('{{ID}}', userId.toString()))
            .then((response) => {
                resolve(response);
            })
            .catch((error) => {
                reject(error);
            });
    });
};
